import React from 'react';
import api from 'api';
import { Button, Icon } from 'b3';

//C3 Modal
export default class ConfirmationModal extends React.Component {
    handleClose(){
        this.props.onCancel();
    }

    async handleComplete(){
        var { action = "delete", actionUrl } = this.props;

        if(actionUrl){
            switch(action.toUpperCase()){
                case "GET":
                    await api.get(actionUrl);
                break;

                case "POST":
                    await api.post(actionUrl);
                break;

                case "PUT":
                    await api.put(actionUrl);
                break;

                case "DELETE":
                    await api.delete(actionUrl);
                break;
            }
        }

        this.props.onComplete();
    }

    render(){
        var { title = 'Are you sure?', noText = 'Cancel', yesText = 'Confirm', isDanger = true, children } = this.props;

        return(
            <div className="modal--confirmDelete">
                <p className="title">{title}</p>
                
                <div className="children">
                    {children}
                </div>

                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button 
                        type={isDanger ? "primary" : "danger"}
                        onClick={() => this.handleClose() }
                    >
                        {noText} <Icon icon="cross"/> 
                    </Button>

                    <Button 
                        type={isDanger ? "danger" : "primary"}
                        onClick={() => this.handleComplete() }
                    >
                        {yesText} <Icon icon="check-2"/>
                    </Button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/ConfirmationModal.js